import { useState } from "react";

const Information = ({ label, className = 'h-8 w-8 mt-1 ml-2 text-gray-600' }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Info Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className={className}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
        />
      </svg>

      {/* Tooltip Section */}
      {isHovered && (
        <div className="absolute bottom-full mb-3 left-2/2 transform -translate-x-1/2">
          <div className="relative bg-gray-100 text-red-600 border border-red-600 text-xs rounded-md p-2 shadow-md  min-w-[180px]">
            {label}

            <div className="absolute right-1/4 top-full w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-red-600"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Information;